import { render } from "./showProductsCarouselComponent.vue?vue&type=template&id=5b4f6b36"
import script from "./showProductsCarouselComponent.vue?vue&type=script&lang=js"
export * from "./showProductsCarouselComponent.vue?vue&type=script&lang=js"

import "./showProductsCarouselComponent.vue?vue&type=style&index=0&id=5b4f6b36&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/showProductsCarouselComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4f6b36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4f6b36', __exports__)) {
    api.reload('5b4f6b36', __exports__)
  }
  
  module.hot.accept("./showProductsCarouselComponent.vue?vue&type=template&id=5b4f6b36", () => {
    api.rerender('5b4f6b36', render)
  })

}


export default __exports__